import { Link, useNavigate } from "react-router-dom";
import { Page } from "../../components/page/page";
import { ProfileChip } from "../../components/profile-chip/profileChip";
import { useUser } from "../../hooks/use-user/useUser";
import { useStore } from "../../hooks/use-store/useStore";
import { Logout } from "../../components/logout/logout";
import { useLocalization } from "../../hooks/use-localization/useLocalization";

export const Home: React.FC = () => {
  const store = useStore();
  const { user } = useUser();
  const navigate = useNavigate();
  const { localize } = useLocalization();

  if (user && store.app) {
    return (
      <Page title="Velg bruker">
        <ProfileChip
          url={`/${store.app.name}/api/autologin`}
          name={user.name || user.firstName}
          lowerText={user.email}
          imageUrl={user.profileImage}
        />
        <Link to={`/${store.app.name}/administrer`} className="button primary">
          {localize("home:admin")}
        </Link>
        <Logout onLogout={() => navigate("logg-inn", { relative: "path" })} />
      </Page>
    );
  }

  return <Page />;
};
